var CookiesNotice = (function($) {

  var _s = {
    container: '.cookies-notice',
    toggle: '.js-toggle-cookies-notice',
    accept_cookies: '.cookies-notice .accept-cookies',
  };

  var _init = function() {
    _bindEvents();

    const cookiesActive = localStorage.getItem('cookiesActive');
    console.log('Cookies Active = '+cookiesActive);

    if ( cookiesActive !== 'true' ) {
      $(_s.container).addClass('active');
    }
  };

  var _bindEvents = function() {
    $(document).on('click', _s.accept_cookies, function() {
      localStorage.setItem('cookiesActive', 'true');
      $(_s.container).remove();
    });
    
  };

  return {
    init: _init
  };

})(jQuery);